// This component sets up the Algolia `InstantSearch` context with a localized product index.
// It initializes the search client using Algolia credentials and wraps its children with the provider.
// Used to enable Algolia search features like recommendations or carousels.

import React, { useMemo } from 'react';
import { liteClient } from 'algoliasearch/lite';
import { useLocalizedIndex } from 'providers/algolia/localized-index';
import { InstantSearch } from 'react-instantsearch-core';

interface AlgoliaRecommendationProviderProps {
  children: React.ReactNode;
}

export default function AlgoliaRecommendationProvider({ children }: AlgoliaRecommendationProviderProps) {
  const searchClient = useMemo(
    () =>
      liteClient(
        process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID as string,
        process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY as string,
      ),
    [],
  );

  const { indexName } = useLocalizedIndex({ type: 'products' });

  if (!indexName) return null;

  return (
    <InstantSearch searchClient={searchClient} indexName={indexName}>
      {children}
    </InstantSearch>
  );
}
